var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGodtvplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(-476 -309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    transform: "translate(476 309)",
    fill: "rgba(196,196,196,0.48)",
    stroke: "#fff",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 82.5,
    r: 82.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 82.5,
    r: 78.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M42.676,3.015a2,2,0,0,1,3.468,0L87.1,74.238a2,2,0,0,1-1.734,3H3.457a2,2,0,0,1-1.734-3Z",
    transform: "translate(605.449 346.875) rotate(90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodtvplay);
export default __webpack_public_path__ + "static/media/godtvplay.77d997d568c37c11f56bc6cc3f25dfb6.svg";
export { ForwardRef as ReactComponent };